import utils from '@/app/utils/utils';
import { toNumber } from 'lodash-es';

export const capitalizeFirstLetter = (value: string) =>
  value ? value.toString().charAt(0).toUpperCase() + value.toString().slice(1) : '';

export const formatRooms = (str: string) => (str ? str.replace(/,/g, ', ').replace(/\+/g, ' + ') : '');

export const yesNo = (value: any) => (!!value ? 'Kyllä' : 'Ei');

export const number = utils.formatNumber;

type EuroOptions = {
  isPrecise?: boolean;
  dashify?: boolean;
  perPerson?: boolean;
  perMonth?: boolean;
};

export const euro = (value: any, options: EuroOptions = {}) => {
  const formatted = options.isPrecise ? utils.formatNumber(value, 2) : utils.formatNumber(value, 0);

  // Dashify after rounding to catch 0.01 values
  if (options.dashify && toNumber(formatted) <= 0) {
    return '-';
  }

  let unit = '€';
  if (options.perPerson) {
    unit += '/hlö';
  }
  if (options.perMonth) {
    unit += '/kk';
  }

  return `${formatted} ${unit}`;
};
